<template>
    <path fill-rule="evenodd" d="M26 12.001c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2s2-.9 2-2v-8c0-1.1-.9-2-2-2zm-24 0c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2s2-.9 2-2v-8c0-1.1-.9-2-2-2zM22.999 12v11c0 1.658-1.343 3-3 3v4c0 1.1-.9 2-2 2s-2-.9-2-2v-4h-4v4c0 1.1-.9 2-2 2C8.9 32 8 31.1 8 30v-4l-.176-.004C6.249 25.904 5 24.599 5 23h-.001V12h18zM18.092.553c.248-.494.85-.694 1.346-.447.496.247.697.847.449 1.342l-1.004 2.001c2.214 1.433 3.76 3.805 4.064 6.55H23V11H5v-1c.304-2.747 1.85-5.118 4.063-6.551L8.06 1.448C7.812.953 8.013.353 8.508.106c.496-.247 1.099-.047 1.346.447l1.008 2.008.262-.103C12.02 2.16 12.977 2 13.974 2c.996 0 1.953.16 2.849.458l.262.103zM11.002 6C10.448 6.001 10 6.447 10 7c0 .552.448 1 1 1l.116-.007c.498-.058.884-.482.884-.994 0-.551-.446-.998-.997-.999zm6 0C16.447 6.001 16 6.447 16 7c0 .552.448 1 1 1l.116-.007c.498-.058.884-.482.884-.994 0-.551-.446-.998-.997-.999z"/>
</template>

<script>
export default {
    name: 'androidIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 28 32');
    }
};
</script>
